import {useEffect, useState} from 'react';
import {useToast} from '@chakra-ui/react';
import axios from 'axios';

export default function useAccountDirectory(kind: 'customers' | 'providers', page: number, deleted: boolean, filters: Record<string, string>, enabled = true) {
  const [records, setRecords] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error,setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const toast = useToast();
  const params = new URLSearchParams({page: String(page), limit: '25', deleted: String(deleted)});
  Object.entries(filters).forEach(([key, value]) => {if (value.trim()) params.set(key, value.trim());});
  const query = params.toString();

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setRecords([]); setTotalRecords(0); setError(false);
    if (!enabled) {setLoading(false); return () => controller.abort();}
    setLoading(true);
    const timer = window.setTimeout(async () => {
      try {
        const response = await axios.get(`https://api.pureworker.com/api/admin/${kind}?${query}`, {
          headers: {Authorization: `Bearer ${localStorage.getItem('AuthToken')}`},
          withCredentials: true,
          signal: controller.signal,
        });
        if (!active) return;
        setRecords(response.data[kind].results);
        setTotalRecords(response.data[kind].totalRecords);
      } catch {
        if (!active) return;
        setError(true);
        setRecords([]);
        setTotalRecords(0);
        toast({title: 'Search failed', description: 'Could not load accounts. Try searching again.', status: 'error', duration: 4000, isClosable: true});
      } finally {
        if (active) setLoading(false);
      }
    }, 250);
    return () => {active = false; controller.abort(); window.clearTimeout(timer);};
  }, [kind, query, revision, toast, enabled]);

  return {records, totalRecords, loading, error, refresh: () => setRevision(value => value + 1)};
}
